import * as React from "react";
import { Switch, Route } from "react-router-dom";
import { MepAnalysisListScreen } from "./MepAnalysisListScreen";
import { MepSessionsListScreen } from "./MepSessionsListScreen";
import { MepAnalysisScreen } from "./MepAnalysisScreen";
import { PrivateRoute } from "../../../Core/PrivateRoute";
import { PermissionEnum } from "../../../misc/api/ApiPermissionEnum";

export const MepRoot = () => {
    return (
        <Switch>
            <PrivateRoute path="/Mep" exact permissions={[PermissionEnum.AccessSingleMepSession, PermissionEnum.AccessAllMepSessions, PermissionEnum.OverreadMepSession]}>
                <MepSessionsListScreen />
            </PrivateRoute>
            <PrivateRoute path="/Mep/Analysis" exact permissions={[PermissionEnum.OverreadMepSession]}>
                <MepAnalysisListScreen />
            </PrivateRoute>
            <PrivateRoute path="/Mep/Analysis/:analysisSetId/:viewState" permissions={[PermissionEnum.OverreadMepSession, PermissionEnum.AccessSingleMepSession]}>
                <MepAnalysisScreen />
            </PrivateRoute>
        </Switch>
    );
}
